import { createStore } from "vuex";
import bookings from './modules/bookings'
import userRoles from './modules/userRoles'

export default createStore({
  state: {
    //App version
    version: "v1.0.5",
    // Security state
    protectedSections: {
      finance: {
        requiresAuth: false,
        isAuthenticated: false
      },
      gallery: {
        requiresAuth: false,
        isAuthenticated: false
      },
      services: {
        requiresAuth: false,
        isAuthenticated: false
      },
      bookings: {
        requiresAuth: false,
        isAuthenticated: false
      },
      leads: {
        requiresAuth: false,
        isAuthenticated: false
      },
      customers: {
        requiresAuth: false,
        isAuthenticated: false
      },
      inventory: {
        requiresAuth: false,
        isAuthenticated: false
      },
      employees: {
        requiresAuth: false,
        isAuthenticated: false
      }
    },
    referralID: "",
    globalDate: null,
    viewingDate: null,
    radiiCheck: true,
    radiiResult: {
      position: {
        lat: 0,
        lng: 0,
      },
      signupStage: "",
      address: {
        completeAddress: "",
        companyAddress: "",
        companyCity: "",
        companyProvince: "",
        companyCountry: "",
        companyAddress: "",
        companyPostal: "",
      },
    },
    whiteLabelClient: null,
    demoProfile: null,
    toggleShortSlideOverPanel: false,
    retrievedKeyMetricsData: {},
    hasSubscribed: false,
    subscriptionStatus: null,
    //Onboarding
    onboardSteps: 0,
    onboardingAid: { tintSeries: [] },
    id: "",
    //Video Walkthroughs
    videoTitle: "",
    videoLink: "",
    videoOpen: false,
    onboardingOpen: false,
    //Customers and Bookings
    customers: {},
    bookingListOpen: false,
    /** Timestamp (ms) until which nested overlay closes must not dismiss the customer profile dialog. */
    customerProfileCloseGuardUntil: 0,
    /** Quick quote matrix slide-over (tint + PPF; see quickQuoteProduct). */
    quickQuoteOpen: false,
    /** null = product chooser; 'tint' | 'ppf' = matrix body for that product only. */
    quickQuoteProduct: null,
    /** Prefill for Create booking when opened from a lead or customer profile. Cleared after useBookingForm applies it. */
    bookingPrefillFromLead: null,
    /** Active warranty-job context while the booking slide-over is open. */
    bookingWarrantyContext: null, // { isWarranty, warrantySource, relatedBookingId, relatedWarrantyId? }
    /** When true, create a film warranty certificate for the original install after a warranty job is booked. */
    createFilmWarrantyForOriginalInstall: false,
    /** Normalized booking data for createWarranty() on the original install (prior_booking flow). */
    originalBookingWarrantyData: null,
    /** Lead selections for pre-highlighting in booking flow (serviceType, vehicleType, ppfTierName?, installType?). Cleared when slide over closes. */
    bookingLeadSelections: null,
    /** Vehicle brands from assets/vehicles (for booking brand→model→segment flow). */
    vehicles: [],
    /** Booking vehicle picker state: step ('brand'|'model'|'segment'), selectedBrand, selectedModel. Cleared on reset/close. */
    bookingVehiclePicker: {
      step: 'brand',
      selectedBrand: null,
      selectedModel: null,
    },
    selectedCustomerBookings: {},
    sendReviewRequestToggled: true,
    bookingViews: {
      serviceTypeSelected: false,
      vehicleTypeSelected: false,
      filmOptionSelected: false,
      installTypeSelected: false,
      timeSlotSelected: false,
      shadeOptionSelected: false,
      bookingComplete: false,
    },

    // Modals
    tintBrandsModal: false,
    //SERVICES
    serviceType: null,
    customServiceName: null,
    customBooking: {
      duration: null,
      price: null,
      bookingNotes: "",
    },
    selectedService: {
      service: "",
      active: false,
    },

    //SMART CARDS
    editCardOpen: false,
    chooseSmartCardOpen: false,
    smartCardList: [],
    selectedSmartCard: {},
    smartCardPaid: false,
    smartCardType: "",
    //////////////////////////////////////

    //TINT SERVICES OPTIONS
    tintOptions: {
      selectorPanelOpen: false,
      shades: [],
      filmType: "",
      filmDescription: "",
      index: null,
      optionsObject: {},
    },
    flatGlassData: {
      config: {
        isOffering: false,
      },
      installPackages: [
        {
          active: false,
        },
        {
          active: false,
        },
        {
          active: false,
        },
      ],
    },
    ppfData: {
      config: { 
        isOffering: false,
        skipIntroScreen: false
      },
      vehicleTypes: [
        { name: "Commuter", active: true },
        { name: "Commercial", active: true },
        { name: "Construction", active: true },
        { name: "Maritime", active: true },
      ],
      // Legacy installPackages array (for inquiry settings - backward compatibility)
      installPackages: [
        { name: "Partial Hood", active: true },
        { name: "Full Front", active: true },
        { name: "Partial Vehicle", active: true },
        { name: "Entire Vehicle", active: true },
      ],
      // New installPackages object structure (for pricing - keyed by vehicle type)
      // Structure: { "Sedan": { "Tier 1 - Partial Front": { ... }, ... }, ... }
      // This will be stored in Firestore at services/ppf/installPackages
      // and loaded dynamically when needed
    },
    vinylData: {
      config: {
        isOffering: false,
      },
      installPackages: [
        {
          active: false,
        },
        
        {
          active: false,
        },
        
        {
          active: false,
        },
        
        {
          active: false,
        },  
      ],
      vehicleTypes: [
        { name: "Commuter", active: true },
        { name: "Commercial", active: true },
        { name: "Construction", active: true },
        { name: "Maritime", active: true },
      ],
    },
    //CUSTOM PRICES
    myCustomPriceListOpen: false,
    myCustomPriceList: [],
    myCustomPriceInstallPackages: null,
    //Lead View
    leadView: false,
    //BookDemo
    demoDateTimeSelected: null,
    demoCompleted: false,
    // Calendly integration fields (kept for backward compatibility)
    demoStatus: 'pending', // 'pending' | 'booked' | 'completed' | 'cancelled'
    demoBookingId: null,
    demoScheduledDate: null,
    demoScheduledTime: null,
    calendlyEventUri: null,
    // Zoom Scheduler integration fields
    zoomSchedulerEventId: null,
    zoomMeetingId: null,
    zoomMeetingLink: null,
    zoomMeetingPassword: null,
    demoBooked: false, // Track if user has completed demo booking
    // Access Code
    accessCode: "",
    // Adding Manufacturer To Tint Bolt
    manufacturerSeries: {},
    //Warranties
    pendingWarranties: [],
    selectedPendingWarranty: null,
    selectedPendingWarranty_Id: "",
    //Metrics
    keyMetricsData: {},
    previousMetricsData: {},
    // Accounting
    monthView: "",
    projectionsView: true,
    projectedRevenue: {
      bookings: [],
      monthlyTotal: 0,
      previousMonthlyTotal: 0,
      estimatedTotal: 0,
      ascending: false,
    },
    accounting: {
      monthSelected: "",
      yearSelected: "",
      revenue: {},
      projected: {},
      expenses: {
        cos: {
          costOfFilm: {},
          shippingCost: {},
          paymentProcessing: {
            percent: 0,
            fee: 0,
            total: 0,
          },
        },
        opex: {
          default: {
            shopRent: 0,
            phoneCost: 0,
            tax: "0.00",
            tintBoltCost: 0,
          },
          expenseList: [],
          user: {},
        },
      },
      pl: {
        revenue: 0,
        cos: 0,
        opex: 0,
        payProcessing: 0,
        taxes: 0,
        grossProfit: 0,
        grossMargin: 0,
        netProfit: 0,
        netMargin: 0,
        profitMargin: 0,
      },
      personalFinance: {
        expenseList: [],
        extraIncome: {},
        expenses: {},
      },
    },
    userExpenseCreator: {
      fixedVariable: {
        open: false,
      },
      percent: {
        open: false,
      },
    },
    //Theme Options Nav States
    themeOptionsNav: {
      themeColor: true,
      backgroundImages: false,
      visibilityOptions: false,
    },
    modifyHours: false,
    modifyHoursInitialTab: 'regular',
    modifyHoursFocusDate: null,
    scheduleRefetchForDate: null,
    companyHours: null,
    //Data points
    vehicleData: {},
    //Lead Gen
    leadGenList: [],
    flatLeadList: [],
    //Is Subscribed
    isSubscribed: true,
    isTrial: true,
    accountLock: false,
    customer: "",
    blankLoader: false,
    //User Config
    userConfig: {},
    //Forgot Password
    forgotPassword: false,
    //Revoke Modal
    revokeOpen: false,
    //Profile Open
    profileOpen: false,
    usersOpen: false,
    integrationsOpen: false,
    referralsOpen: false,
    embedWidgetOpen: false,
    //Manufacturer States
    manufacturerRequestOpen: false,
    //Dashboard View Control
    dashBoardView: "",
    //ADD VEHICLES FOR SYNC TO LIST
    addedVehicles: [],
    //SERVICE ITEMS PULLED FROM SQUARE
    catalogList: [],
    //VEHICLE TYPES AND STATES
    vehicleTypes: [
      { name: "Sedan", selected: false, serviceId: "#sedan" },
      { name: "Compact SUV", selected: false, serviceId: "#compactSUV" },
      { name: "Coupe", selected: false, serviceId: "#coupe" },
      { name: "2DR Truck", selected: false, serviceId: "#twoTruck" },
      { name: "3DR Hatchback", selected: false, serviceId: "#threeHatch" },
      { name: "4DR Truck", selected: false, serviceId: "#fourTruck" },
      { name: "5DR Hatchback", selected: false, serviceId: "#fiveHatch" },
      { name: "Large SUV", selected: false, serviceId: "#largeSUV" },
      { name: "Minivan", selected: false, serviceId: "#minivan" },
      { name: "Wagon", selected: false, serviceId: "#wagon" },
      { name: "Medium SUV", selected: false, serviceId: "#mediumSUV" },
    ],
    // MODES
    automotiveTintMode: "shop",
    automotiveTintModeDB: null,
    automotiveMobileTravelingFee: 0,
    automotiveMobileTravelingDistance: { distance: 0, unit: 0 },
    //BOOKING MODE
    bookingMode: "shop",
    siteReady: false,
    //ADDED VEHICLE LIST
    addedVehiclesList: [],
    //COMPANY PROFILE OBJECT
    companyProfile: {},
    companyPublicProfile: {},
    contentMatrix: {},
    //GALLERY IMAGES
    galleryList: [],
    //SERVICES READY
    serviceReady: false,
    //Booking View
    viewStep: {
      stepOneOpen: true,
      stepTwoOpen: false,
      stepThreeOpen: false,
    },
    //BOOKING HOURS
    openingHour: 0,
    closingHour: 23,
    //BOOKING DATA
    bookingData: {
      vehicle: "",
      install: "",
      price: "",
      selectedDay: "",
      selectedTime: "",
      year: "",
      model: "",
      rearTint: "",
      frontTint: "",
      offSite: false,
      segment: {},
    },
    //BOOKING UI
    activeDateTime: null,
    openBookingUI: false,
    selectedDay: {
      events: [],
    },
    bookingTier: false,
    bookingServiceType: false,
    bookingServicesSelected: false,
    viewBookingDetails: {},
    viewBooking: false,

    viewOtherBookingDetails: {},
    viewOtherBooking: false,

    fetchedBookings: [],
    fetchedOtherBookings: [],
    /** Month/year the current fetchedBookings is for (calendar view). Used so popup only refreshes store when it matches. */
    fetchedBookingsViewMonth: null,
    fetchedBookingsViewYear: null,
    activeStates: {
      activeVehicleType: "",
      activeTier: "",
      activeSeries: "",
      activeServiceType: "",
      activeTimeSlot: null,
      activeInstallDate: null,
      activeShades: [],
    },
    selectedInstall: {
      vehicleType: "",
      installType: "",
      series: "",
      time: "",
      selectedDate: {
        day: "",
        month: "",
        year: "",
        monthName: "",
      },
      selectedServicesList: [],
      servicesSelected: [],
      priceOverrides: {}, // Per-install-type manual price overrides, keyed by serviceName (effective/post-modifier line price)
      ppfConfig: null, // PPF-specific configuration: { installTier, filmChoice, partsCovered }
      bookingMode: null, // 'together' | 'separate' for multi-service bookings
      addingAnotherService: false, // Flag to track when adding another service type
      blockWorkHoursOnly: undefined, // Multi-day: when undefined, uses company multiDayAllowClosedDays config (like QB)
    },
    customer: {},
    bookingDetails: {
      customerDetails: {
        name: "",
        phoneNumber: "",
        email: "",
      },
      vehicleDetails: {
        make: "",
        model: "",
        year: "",
        vehicleType: "",
      },
      installDetails: {
        installType: "",
        shades: { front: "", rear: "" },
        price: null,
        startTime: null,
        endTime: null,
      },
    },
    calendarConfig: {
      duration: null,
    },
    availability: [],
    rawAvailabilityData: [], // Store raw availability response for end time lookup
    selectedMultiDaySlot: null, // Store selected multi-day slot info
    hideCalendar: true,
    availabilityLoading: null,
    tintAvailability: [],
    tintServices: null,
    listBookings: [],
    listLoading: false,
    preListLoad: false,
    //HELP
    helpOpen: false,
    //APPLY FORM
    apply: {
      token: "",
      domain: "",
      analytics: "",
      elfsight: "",
      color: "",
      business: {
        registered: false,
        insured: false,
        licensed: false,
      },
      warranty: {
        standard: "",
        premium: "",
        prestige: "",
      },
    },
    bannerOpen: true,
    currentUser: "",
    authUser: null,
    accountOwnerId: null,
    accountContext: null,
    accountMemberMenuTabsBlocked: [],
    /** Active account member partnerPricing from getDashboardAccountContextV2 / Firestore. */
    accountMemberPartnerPricing: null,
    clientInfo: {
      client: {},
      subscription: {},
    },
    companyInfo: {},
    infoLoaded: false,
    loggedIn: false,
    loading: false,
    loadingSignup: false,
    currentDashboardView: {
      dashboard: true,
      executive: false,
      options: false,
      warranties: false,
      services: false,
      gallery: false,
      bookings: false,
      leads: false,
      finance: false,
      customers: false,
      smartCards: false,
      "shopfront": false,
      inventory: false,
      employees: false,
      accountUsers: false,
      integrations: false,
      referrals: false,
      promoter: false,
      giftCards: false,
      funnels: false,
      scripts: false,
      settings: false,
      feedback: false,
      partnerPricing: false,
      liveChat: false,
      influencers: false,
      partnerActivity: false,
      guides: false,
    },
    tintBrands: [],
    selectedBrand: {},
    selectedTier: "",
    checkOptions: [],
    activeOptions: [],
    checkLoader: true,
    userMeta: {
      configComplete: true,
    },
    companyProfileName: "",
    showHideCreator: false,
    warrantySearchResults: {},
    showHideSearches: false,
    viewWarranty: false,
    clientNumber: "",
    clientWarranty: {},
    clientWarrantyId: "",
    openTintCreate: false,
    optionInCreation: {},
    companyName: "",
    shopWarrantyId: {},
    chosenManufacturer: {
      tintBrandName: "",
      seriesList: {},
    },
    //Chosen Brand
    settingFilmQuality: "",
    shadesObj: {},
    tierSettings: {},
    seriesList: "",
    services: [],
    smsSegments: null,
    flatGlassInquiries: {
      total: 0,
      new: 0
    },
    ppfInquiries: {
      total: 0,
      new: 0
    },
    vinylWrapInquiries: {
      total: 0,
      new: 0
    },
    updatePopupRef: null,
    updateSettings: {
      currentVersion: 'v1.0.6',
      hideUpdates: false,
      lastSeenVersion: null,
      isUpdatePopupOpen: false,
      updateData: null
    },
    tintServices: null,
    securitySettings: {
      sections: {},
      sessionTimeout: null,
      hasPassword: false,
      lastFetched: null
    },
    securitySettingsOpen: false,
    tutorialsOpen: false,
    feedbackModalOpen: false,
    feedbackPrefill: null,
    feedbackRefreshTrigger: null,
    feedbackList: [],
    feedbackViewUpdateTrigger: 0, // Trigger for badge recalculation when feedback is viewed
    customerAgentUnreadCount: 0,
    satisfactionSurveyOpen: false,
    accountingConfig: {
      processingMethods: [],
      salesTaxRate: 0,
      includeProcessingFeeInTotal: true
    },
    isTimeModifierOpen: false,
    vehiclesUpdated: false,
    squareConnected: false,
    /** When true, BackOfficePanel skips idle-triggered full page reload (install workflow). */
    blockIdleReload: false,
  },
  getters: {
    getViewBookingDetails: (state) => {
      return state.viewBookingDetails;
    },
  },
  mutations: {
    // Define mutations if you need to modify viewBookingDetails
    setViewBookingDetails(state, payload) {
      state.viewBookingDetails = payload;
    },
    setViewBooking(state, value) {
      state.viewBooking = value;
    },
    setViewOtherBookingDetails(state, payload) {
      state.viewOtherBookingDetails = payload;
    },
    setViewOtherBooking(state, value) {
      state.viewOtherBooking = value;
    },
    SET_MODIFY_HOURS(state, value) {
      state.modifyHours = value;
    },
    SET_MODIFY_HOURS_INITIAL_TAB(state, value) {
      state.modifyHoursInitialTab = value;
    },
    SET_MODIFY_HOURS_FOCUS_DATE(state, value) {
      state.modifyHoursFocusDate = value;
    },
    SET_SCHEDULE_REFETCH_FOR_DATE(state, value) {
      state.scheduleRefetchForDate = value;
    },
    updateSendReviewRequestToggled(state, newValue) {
      state.sendReviewRequestToggled = newValue;
    },
    setAutomotiveTintMode(state, mode) {
      state.automotiveTintMode = mode;
    },
    setAutomotiveMobileTravelingFee(state, fee) {
      state.automotiveMobileTravelingFee = fee;
    },
    setAutomotiveMobileTravelingDistance(state, distance) {
      state.automotiveMobileTravelingDistance = distance;
    },
    setAutomotiveTintModeDB(state, mode) {
      state.automotiveTintModeDB = mode;
    },
    setBookingMode(state, mode) {
      state.bookingMode = mode;
    },
    SET_FLAT_GLASS_INQUIRIES(state, { total, new: newCount }) {
      state.flatGlassInquiries.total = total;
      state.flatGlassInquiries.new = newCount;
    },
    SET_PPF_INQUIRIES(state, { total, new: newCount }) {
      state.ppfInquiries.total = total;
      state.ppfInquiries.new = newCount;
    },
    SET_VINYL_INQUIRIES(state, { total, new: newCount }) {
      state.vinylWrapInquiries.total = total;
      state.vinylWrapInquiries.new = newCount;
    },
    SET_UPDATE_POPUP_REF(state, ref) {
      state.updatePopupRef = ref
    },
    SET_HIDE_UPDATES(state, value) {
      state.updateSettings.hideUpdates = value
    },
    SET_LAST_SEEN_VERSION(state, version) {
      state.updateSettings.lastSeenVersion = version
    },
    SET_UPDATE_POPUP_OPEN(state, value) {
      state.updateSettings.isUpdatePopupOpen = value
    },
    SET_UPDATE_DATA(state, data) {
      state.updateSettings.updateData = data
    },
    // Add mutations for security state
    SET_SECTION_REQUIRES_AUTH(state, { section, value }) {
      if (state.protectedSections[section]) {
        state.protectedSections[section].requiresAuth = value;
      }
    },
    SET_SECTION_AUTHENTICATED(state, { section, value }) {
      if (state.protectedSections[section]) {
        state.protectedSections[section].isAuthenticated = value;
      }
    },
    SET_SECURITY_SETTINGS(state, settings) {
      state.securitySettings = {
        ...settings,
        lastFetched: new Date().getTime()
      }
    },
    UPDATE_SECTION_SECURITY(state, { section, requiresPassword }) {
      state.securitySettings.sections = {
        ...state.securitySettings.sections,
        [section.toLowerCase()]: requiresPassword
      }
    },
    SET_SESSION_TIMEOUT(state, timeout) {
      state.securitySettings.sessionTimeout = timeout
    },
    SET_HAS_PASSWORD(state, hasPassword) {
      state.securitySettings.hasPassword = hasPassword
    },
    SET_SECURITY_SETTINGS_OPEN(state, value) {
      state.securitySettingsOpen = value;
    },
    SET_TUTORIALS_OPEN(state, value) {
      state.tutorialsOpen = value;
    },
    SET_TIME_MODIFIER_OPEN(state, value) {
      state.isTimeModifierOpen = value;
    },
    SET_BLOCK_IDLE_RELOAD(state, value) {
      state.blockIdleReload = Boolean(value);
    },
    SET_VEHICLES_UPDATED(state, value) {
      state.vehiclesUpdated = value;
      // Reset after a short delay to allow components to detect the change
      if (value) {
        setTimeout(() => {
          state.vehiclesUpdated = false;
        }, 1000);
      }
    },
    SET_SQUARE_CONNECTED(state, isConnected) {
      state.squareConnected = isConnected;
    },
    SET_LOADING(state, isLoading) {
      state.loading = isLoading;
    },
    SET_INTEGRATIONS_OPEN(state, value) {
      state.integrationsOpen = value;
    },
    SET_FETCHED_BOOKINGS(state, bookings) {
      state.fetchedBookings = Array.isArray(bookings) ? bookings : [];
    },
    SET_FETCHED_BOOKINGS_VIEW(state, { month, year }) {
      state.fetchedBookingsViewMonth = month ?? null;
      state.fetchedBookingsViewYear = year ?? null;
    },
  },
  actions: {},
  modules: {
    bookings,
    userRoles
  }
});
